import React, { useState, useEffect } from "react";
import { auth } from "../Firebase/FirebaseConfig";
import yourImage from "../Craft_LightCentered [1024].png";
import "../styles/Header.css";
import LoginForm from "../forms/LoginForm";
import UserProfile from "./UserProfile";
import AppStoreLinks from "./AppStoreLinks";
import { NavLink } from "react-router-dom";

const Header = () => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
    });

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  return (
    <header className="site-header">
      <div className="header-container">
        <NavLink className="brand" to="/about" aria-label="CRAFT home">
          <img
            src={yourImage}
            alt=""
            className="brand__logo"
          />
          <span className="brand__name">CRAFT</span>
          <span className="brand__tagline">The Social Beer App</span>
        </NavLink>

        <nav className="navigation-links" aria-label="Main navigation">
          <NavLink to="/about">About</NavLink>
          <NavLink to="/support">Support</NavLink>
          <NavLink to="/privacy-policy">Privacy</NavLink>
        </nav>

        <div className="header-actions">
          {!currentUser && <AppStoreLinks compact />}
          {currentUser ? (
            <UserProfile userEmail={currentUser.email} />
          ) : (
            <details className="login-panel">
              <summary>Sign in</summary>
              <div className="login-panel__content">
                <p className="login-panel__title">Welcome back</p>
                <LoginForm />
              </div>
            </details>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
